/* eslint-disable react/prop-types */
import { colors, strCode } from "../../../../consts";
import { CellWrapper } from "../../../../components/Table/styled";
import { Paragraph2 } from "../../../../components";

export const MissingKeysModalTableColumns = [
  {
    Header: strCode.MISSING_KEY_TITLE,
    accessor: "missingKey",
    Cell: ({ cell }) => {
      return (
        <CellWrapper width="50%" minWidth="386px">
          <Paragraph2 style={{ color: colors.ERROR, wordBreak: "break-all" }}>
            {cell.value}
          </Paragraph2>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.DEFAULT_LOCALIZATION_TITLE,
    accessor: "defaultLocalization",
    Cell: ({ cell }) => {
      return (
        <CellWrapper width="100%">
          <Paragraph2>{cell.value}</Paragraph2>
        </CellWrapper>
      );
    }
  }
];
